import React from 'react'
import Services from '../Services'
import Navbar from '../navbar'
import Footer from '../Footer'

function ServicePage() {
  return (
    <>
    <Navbar/>
    <Services/>
    <br/><br/><br/>
    <Footer/>
    </>
  )
}

export default ServicePage